import React from 'react';

export default function CalendarPage() {
	return (
		<div className="p-10 text-center">
			Tu powstanie strona dotycząca kalendarza...
		</div>
	);
}
